import { useHistory, useLocation } from "react-router-dom";
import { Form } from "@circle-react-uikit/Form";
import { SendUsAMessageForm } from "../../Form";
import { SEND_MESSAGE_FORM_DEFAULT_VALUES } from "../../constants";
import { useCreateConversation } from "../../queries";
import { CREATE_CONVERSATION_SCHEMA } from "../../schemas";

export const CreateConversationView = () => {
  const history = useHistory();
  const location = useLocation();
  const { mutate: createSupportWidgetConversation, isLoading } =
    useCreateConversation({
      source: location.state?.source,
      chatBotSessionId: location.state?.chatBotSessionId,
      onSuccess: ticket => {
        history.push(`/conversations/${ticket.id}`, {
          from: "CreateConversationView",
        });
      },
    });

  return (
    <div className="flex flex-col">
      <div className="grow overflow-y-auto">
        <Form
          preventAccidentalLeave
          validationSchema={CREATE_CONVERSATION_SCHEMA}
          id="send-message-form"
          onSubmit={createSupportWidgetConversation}
          mode="onSubmit"
          defaultValues={SEND_MESSAGE_FORM_DEFAULT_VALUES}
        >
          <SendUsAMessageForm isLoading={isLoading} />
        </Form>
      </div>
    </div>
  );
};
